module.exports = __webpack_public_path__ + "media/components/resort-webcams/static/snoweye-logo-be15c50e9613744492935ec980d8480c.gif";